module.exports = __webpack_public_path__ + "media/images/icons/twotone/picture-81a5d47560e5ee6566c38aa3d57d3321.svg";